























































































import { Component, Vue } from 'vue-property-decorator';
import { doublePrevention, patrolManagementServe, performanceServer } from '@/api/installServer';
import publishObjectPath from '@/util/configRegistry';

@Component
export default class DialogDetail1 extends Vue {
  private dialogVisible = false;
  private imagesList: any = [];
  private picPath: any = '';
  private imgPath: any = 'data:image/jpeg;base64,';

  // 表单数据
  private formData: any = {};
  public async showDialog(data: any) {
    this.imagesList = [];
    this.picPath = publishObjectPath.imgPathWater;
    this.getPatrolHazardCheckData(data.id);
    this.dialogVisible = true;
  }
  getPatrolHazardCheckData(id: any) {
    // 发起接口请求，获取分页数据
    doublePrevention
      .getPatrolHazardCheckShellDetail(id)
      .then(async (res: any) => {
        this.formData = res.data;
        const resInner: any = await this.getSignatureData(res.data.staffSign);
        this.formData.staffSign = resInner.signature;
        this.getSysFile(res.data.images);
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }
  /**
   * @desc 获取签名人信息
   * @param1 暂无
   * @returns 暂无
   */
  getSysFile(id: any) {
    performanceServer.getSysFile(id).then((res: any) => {
      this.imagesList = res.data;
    });
  }

  /**
   * @desc 获取签名人信息
   * @param1 暂无
   * @returns 暂无
   */
  async getSignatureData(id: any) {
    if (id) {
      const res: any = await performanceServer.getStaffInfo(id);
      return res.data;
    } else {
      return '';
    }
  }

  handleClose(done: any) {
    done();
  }
}
